import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AngularEditorComponent,
  AngularEditorConfig,
} from "@kolkov/angular-editor";
import {
  NgbAccordionConfig,
  NgbModal,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { CrudService } from "src/app/Services/crud.service";
import { FormStateService } from "src/app/Services/form.service";
import { LogedInUserService } from "src/app/Services/loged-in-user.service";
import { ThemeOptions } from "src/app/theme-options";
import { environment } from "src/environments/environment";
import { MatTabsModule } from "@angular/material/tabs";
import { GenerateAiContentComponent } from "src/app/Modals/generate-ai-content/generate-ai-content.component";
import { LoadingService } from "src/app/Services/loading.service";
@Component({
  selector: "app-dynamic-userguide-form",
  templateUrl: "./dynamic-userguide-form.component.html",
  styles: [
    `
      ::ng-deep .ng-select .ng-select-container {
        border-radius: 0.15rem;
        min-height: 10px;
        -ms-flex-align: center;
        align-items: center;
        background-color: #ffffff;
        border: 1px solid black;
      }

      ::ng-deep
        .ng-select.ng-select-multiple
        .ng-select-container
        .ng-value-container
        .ng-placeholder {
        top: 10px;
        padding-bottom: 0px;
        color: black;
      }
      ::ng-deep .applied-class {
        display: inline-block;
        margin: 5px !important;
        padding: 5px !important;
        margin: 5px !important;
        border: 1px solid grey !important;
        border-radius: 5px !important;
      }

      .role-tooltip {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 5px 10px;
        border-radius: 4px;
        font-size: 12px;
        pointer-events: none;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      }

      ::ng-deep .ae-picker-options {
        position: absolute;
        z-index: 1100 !important;
        background: white;
      }
    `,
  ],
  standalone: false,
})
export class DynamicUserguideFormComponent implements OnInit, AfterViewInit {
  @HostListener("click", ["$event"])
  onClick(event: MouseEvent) {
    const selection = window.getSelection();
    if (
      selection &&
      !selection.isCollapsed &&
      selection.toString().trim().length > 0
    ) {
      return;
    } else {
      this.selectedRoles = [];
    }
  }

  @Input() userguide;
  @Input() screen;
  @Input() project;
  @Input() projectVersion;
  @Input() selectedEnv;
  @Input() defaultTemplate;
  @Input("roles") roles;
  private isSelectingText: boolean = false;
  private isDropdownOpen: boolean = false;
  closeResult;
  @ViewChild("faq-editor1") ugTextarea!: ElementRef;
  @ViewChild(AngularEditorComponent)
  editor!: AngularEditorComponent;
  @ViewChild("editor", { static: true }) editorRef!: ElementRef;

  @ViewChild("dropdown") roleDropdown;
  isDropdownVisible: boolean = false;
  @Output()
  onLanguageChange = new EventEmitter<any>();
  @Output() formSubmitted: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild("rolesDropdown", { read: ElementRef })
  dropdownElement: ElementRef;

  selectedRange: Range | null = null;

  imageLength = 10;
  form: UntypedFormGroup;
  disbledPublishtoDev: boolean = true;
  currentUserGuide;
  languageList = [];
  disableSave = false;
  publishToProd = false;
  publishToQA = false;
  addUserGuide = false;
  versionList = [];
  submitted = false;
  textError = false;
  imageError = false;
  workflowList = [];
  faqList = [];
  ugClassList = [];
  imageapiUrl: string;
  downloadAPI: string;
  uploadAPI: string;
  linkedFaq: any;
  selectedRoles: any[] = [];
  dropdownSelection: any = [];
  selectedElment;
  dropdownStyle: any = {};
  existingUserguides = [];
  selectionRange: Range | null = null;
  // angular-editor ngmodel
  editorContent;
  rolesObject: any = {};
  isLoading = false;
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "15rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "yes",
    sanitize: false,
    upload: (file: File) => this.uploadImage(file),
  };
  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private logedInUserService: LogedInUserService,
    private sanitizer: DomSanitizer,
    private router: Router,
    public globals: ThemeOptions,
    private modalService: NgbModal,
    private formStateService: FormStateService,
    private el: ElementRef,
    private loadingService: LoadingService,
    private cdRef: ChangeDetectorRef
  ) {
    this.getLanguages();
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngAfterViewInit(): void {
    const editorElement = this.el.nativeElement.querySelector(
      ".angular-editor-textarea"
    );

    if (!editorElement) return;

    // Initial setup for existing spans
    this.updateSpansWithTooltips(editorElement);

    // Observe for future changes
    const observer = new MutationObserver(() => {
      this.updateSpansWithTooltips(editorElement);
    });

    observer.observe(editorElement, { childList: true, subtree: true });
  }

  private updateSpansWithTooltips(editorElement: HTMLElement) {
    const spanElements = editorElement.querySelectorAll("span");

    spanElements.forEach((spanElement: HTMLElement) => {
      const classes = Array.from(spanElement.classList);
      const roleClasses = classes.filter((className) =>
        className.startsWith("_tas-role-")
      );

      if (
        roleClasses.length > 0 &&
        !spanElement.hasAttribute("data-tooltip-set")
      ) {
        // Avoid duplicate listeners
        spanElement.setAttribute("data-tooltip-set", "true");

        const classNamesWithoutPrefix = roleClasses.map((className) =>
          className.replace("_tas-role-", "")
        );

        spanElement.addEventListener("mouseover", () => {
          const updatedValues = classNamesWithoutPrefix.map(
            (classNameWithoutPrefix) => this.rolesObject[classNameWithoutPrefix]
          );
          const classNamesString = updatedValues.join(", ");
          spanElement.setAttribute("title", classNamesString);
        });
      }
    });

    // Also update dropdown based on current selection
    this.setDropdownValueBasedOnSpan();
  }

  ngOnInit() {
    this.userguide == "new"
      ? (this.addUserGuide = true)
      : (this.addUserGuide = false);
    this.getWorkflowList = this.getWorkflowList.bind(this);
    this.getWorkflowList();

    this.showSelectedLangaugeUserGuide.bind(this);
    this.form = this.formBuilder.group({
      name: ["", Validators.required, ""],
      text: ["", Validators.required, ""],
      projectVersion: [],
      languageId: [],
      screenManagementId: [],
      projectManagementId: [],
      id: [],
      linkedFAQ: [""],
      linkedWorkflow: [""],
      roles: [""],
    });

    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        this.disbledPublishtoDev = false;
        this.formStateService.setFormDirty();
      }
    });
    if (this.defaultTemplate && !this.form.value.text) {
      this.form.patchValue({ text: this.defaultTemplate });
    }

    this.currentUserGuide = Object.assign(
      {},
      this.addUserGuide == false ? this.userguide : null
    );
    this.form.patchValue(this.currentUserGuide);

    this.editorContent = this.currentUserGuide.text;
    if (!this.addUserGuide) {
      this.getlastPublishStage(this.currentUserGuide.userGuideId);
    }
    this.setApiUrl();
    if (this.roles.length) {
      this.roles.map((item) => {
        this.rolesObject[item.name] = item.displayname;
      });
    }
    this.getExistinguserguides();
  }

  getWorkflowList() {
    let self = this;
    let query = `screenManagementId=${self.screen.id}&publishStage=${self.selectedEnv}&projectVersion=${self.projectVersion}&projectManagementId=${this.project.id}`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.workflowList = response;
        } else {
          self.workflowList = [];
        }
        self.getFaqList();
      },
      "workflows/getWorkflowsForWebAndPlugin?" + query
    );
  }

  getExistinguserguides() {
    let query = `?filter[where][userGuideId]=${this.userguide.userGuideId}`;

    this.crudService.get(
      null,
      (response) => {
        if (response.length > 0) {
          this.existingUserguides = response;
        }
      },
      "currentUserGuideDetails" + query
    );
  }
  getFaqList() {
    let self = this;
    var fordropdown = true;
    let query = `publishStage=${self.selectedEnv}&projectVersion=${self.projectVersion}&projectManagementId=${this.project.id}&fdd=${fordropdown}`;

    self.crudService.get(
      null,
      function (response) {
        if (response) {
          self.faqList = response;
        } else {
          self.faqList = [];
        }
        self.getUGCLassList();
      },
      "faqs/getFaqsForWebAndPlugin?" + query
    );
  }

  getUGCLassList() {
    let self = this;
    let query = `filter[where][projectManagementId]=${self.project.id}&filter[where][projectVersion]=${self.projectVersion}`;

    self.crudService.get(
      null,
      function (response) {
        if (response && response.length) {
          self.ugClassList = response;
        } else {
          self.ugClassList = [];
        }
        self.injectCustomWorkflowDropdown();
      },
      "userGuideClasses?" + query
    );
  }

  setApiUrl() {
    if (environment.production || environment.staging) {
      this.imageapiUrl = `${environment.imageApiBaseUrl}`;
      this.downloadAPI = `${environment.appURL}/api/containers/tas-qa-databucket/download/${this.project.companyId}%2F`;
      this.uploadAPI = `${this.imageapiUrl}/uploadWithFolder?folderName=${this.project.companyId}`;
    } else {
      this.imageapiUrl = `${environment.imageApiBaseUrl}/${this.project.companyId}`;
      this.downloadAPI = `${environment.appURL}/api/${this.imageapiUrl}/download/`;
      this.uploadAPI = `${this.imageapiUrl}/upload`;
    }
  }

  uploadImage(file: File): Observable<any> {
    return new Observable((observer) => {
      const imageUrls = this.countImagesInText(this.form.value.text); // Handle as a number

      if (imageUrls >= this.imageLength) {
        this.imageError = true;
        observer.error("Image limit exceeded");
        observer.complete();
        return;
      } else {
        this.imageError = false;
      }

      const formData = new FormData();
      formData.append("file", file);

      this.crudService.post(
        formData,
        (response) => {
          const filename = response.result.files.file[0].name;
          const imageUrl = `${this.downloadAPI}${filename}`;
          this.insertImageToEditor(imageUrl);
          observer.next(response);
          observer.complete();
        },
        `${this.uploadAPI}`
      );
    });
  }

  insertImageToEditor(imageUrl: string) {
    const html = `<span class=""><img src="${imageUrl}" alt="Image"></span>`;
    const editor = document.querySelector(".angular-editor-textarea");
    editor.innerHTML += html;
    this.form.patchValue({ text: editor.innerHTML });
    this.form.markAsDirty();
  }

  injectCustomWorkflowDropdown() {
    setTimeout(() => {
      var customDiv = document.createElement("div");
      customDiv.style.display = "flex";
      customDiv.style.columnGap = "5px";
      customDiv.style.height = "35px";
      var dropdown = document.createElement("div");
      dropdown.classList.add("angular-editor-toolbar-set");
      dropdown.innerHTML =
        '<label class="block-label" tabindex="-1" for="workflow-faq-editor"></label>' +
        '<select title="Workflow" style="height: 85%;" id="workflow-faq-editor" class="select-custom-style">' +
        '<option value="">Link to Workflow</option>' +
        '<option value="4-workflows">Top 4 workflows</option>' +
        '<option value="all-workflows">All workflows</option>' +
        this.workflowList
          .map(
            (option) => `<option value="${option.name}">${option.name}</option>`
          )
          .join("") +
        "</select>";
      var dropdown2 = document.createElement("div");
      dropdown2.classList.add("angular-editor-toolbar-set");
      dropdown2.innerHTML =
        '<label class="block-label" tabindex="-1" for="class-faq-editor"></label>' +
        '<select title="customclass" style="height: 85%;" id="class-faq-editor" class="select-custom-style">' +
        '<option value="" disabled selected>Apply Class</option>' +
        '<option value="clear-class">Clear Class</option>' +
        '<option value="code">Code</option>' +
        '<option value="navigation">Navigation</option>' +
        '<option value="icon">Icon</option>' +
        '<option value="screenshot">Screenshot</option>' +
        '<option value="notes">Notes/Tips</option>' +
        this.ugClassList
          .map(
            (option) =>
              `<option value="${option.className}">${option.name}</option>`
          )
          .join("") +
        "</select>";

      /* Appending role dropdown */
      var dropdown4 = document.createElement("div");
      dropdown4.classList.add("angular-editor-toolbar-set");
      var rolesDD = document.getElementById("roles-faq-editor");
      rolesDD.style.display = "block";
      dropdown4.append(rolesDD);

      var dropdown3 = document.createElement("div");
      dropdown3.classList.add("angular-editor-toolbar-set");
      var selectedValue = this.linkedFaq;
      // console.log("faqlist in dynamic userguide", this.faqList);

      dropdown3.innerHTML =
        '<label class="block-label" tabindex="-1" for="faq-faq-editor"></label>' +
        '<select title="FAQ" formControlName="linkedFAQ" class="faqlist" style="height: 85%; width:200px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" id="faq-faq-editor" class="select-custom-style">' +
        '<option value="" disabled selected>Link to FAQ</option>' +
        Object.keys(this.faqList)
          .map((key) => {
            // Create the parent optgroup for the key (e.g., Auditlog, Dashboard)
            let keyOption = `<optgroup label="${key}">`;

            // Create the child options for each FAQ item
            let faqOptions = this.faqList[key]
              .map((faq) => {
                // Set the selected attribute if the FAQ question matches the selected value
                return `<option value="${faq.question}" >${faq.question}</option>`;
              })
              .join(""); // Join all FAQ items for the current key

            // Combine the optgroup label and the FAQ options
            return keyOption + faqOptions + `</optgroup>`;
          })
          .join("");

      +"</select>";

      // File Upload Button
      var fileUploadDiv = document.createElement("div");
      fileUploadDiv.classList.add("angular-editor-toolbar-set");
      fileUploadDiv.innerHTML = `
        <button id="file-upload-button" class="select-custom-style" style="height: 85%; display: flex; align-items: center; justify-content: center; background: white; border: 1px solid grey; cursor: pointer;" title="Only .pdf and .docx are supported">
          <i class="fa fa-file-text" style="font-size:20px"></i>
        </button>
        <input type="file" id="file-upload" style="display: none;" accept=".pdf,.docx" />
      `;

      fileUploadDiv
        .querySelector("#file-upload-button")
        .addEventListener("click", () => {
          const fileInput = document.getElementById(
            "file-upload"
          ) as HTMLInputElement;
          fileInput.click();
        });

      const toolbarElements = document.querySelectorAll(
        ".angular-editor-toolbar"
      );
      toolbarElements.forEach((toolbar) => {
        // Check if the dropdown is already present
        if (!toolbar.querySelector("#workflow-faq-editor")) {
          customDiv.append(dropdown);
        }

        if (!toolbar.querySelector("#class-faq-editor")) {
          customDiv.append(dropdown2);
        }

        if (!toolbar.querySelector("#faq-faq-editor")) {
          customDiv.append(dropdown3);
        }

        if (!toolbar.querySelector("#roles-list")) {
          customDiv.append(dropdown4);
        }

        if (!toolbar.querySelector("#file-upload")) {
          customDiv.append(fileUploadDiv);
        }

        const formElement = document.getElementById("formGroup");
        if (formElement) {
          formElement.appendChild(customDiv);
        } else {
          console.log("cannot find the form element");
        }

        let selectElement = document.getElementById("faq-faq-editor");

        if (selectElement && selectElement instanceof HTMLSelectElement) {
          if (this.currentUserGuide) {
            const isOptionAvailable = Array.from(selectElement.options).some(
              (option) => option.value === this.currentUserGuide.linkedFAQ
            );
            if (isOptionAvailable) {
              selectElement.value = this.currentUserGuide.linkedFAQ;
            }
          }
        }
        toolbar.append(customDiv);

        var selected = document.getElementById(
          "workflow-faq-editor"
        ) as HTMLSelectElement;
        selected.addEventListener("change", () => {
          this.handleWorkflowSelection(selected.value);
          selected.value = "";
        });

        var selected2 = document.getElementById(
          "class-faq-editor"
        ) as HTMLSelectElement;
        selected2.addEventListener("change", () => {
          this.handleClassSelection(selected2.value);
          selected2.value = "";
        });

        /* Event handle for faq selection */
        var selected3 = document.getElementById(
          "faq-faq-editor"
        ) as HTMLSelectElement;
        selected3.addEventListener("change", (event) => {
          // console.log("change change change");
          this.disbledPublishtoDev = false;
          const selectedValue = (event.target as HTMLSelectElement).value;
          this.linkedFaq = selectedValue;
          this.handleFaqSelection(selectedValue);
          selected3.value = selectedValue;
        });

        var fileInput = document.getElementById(
          "file-upload"
        ) as HTMLInputElement;
        fileInput.addEventListener("change", (event: Event) => {
          const file = (event.target as HTMLInputElement).files[0];
          if (file) {
            this.handleFileUpload(file);
          }
        });
      });
    }, 200);
  }

  handleFileUpload(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      const base64Content = reader.result as string;
      const fileType = file.type; // e.g., "application/pdf"
      this.translateToHTML(base64Content, fileType);
    };
    reader.readAsDataURL(file);
  }

  translateToHTML(file: string, fileType: string) {
    const payload = { file, fileType };
    this.crudService.post(
      payload,
      (response) => {
        if (response && response.htmlResponse) {
          const editor = document.querySelector(".angular-editor-textarea");
          editor.innerHTML = response.htmlResponse;
          this.form.patchValue({ text: editor.innerHTML });
          this.form.markAsDirty();
        } else {
          this.toastr.error(
            `${response.error.error.message}. Only .pdf and .docx are supported.`,
            "Invalid Operation"
          );
        }
      },
      "userGuides/translateUserGuideToHTML"
    );
  }

  // Helper method to update form content
  updateFormContent() {
    var editorId = document.querySelector(".angular-editor-textarea");
    this.form.setValue({
      name: this.form.value.name,
      text: editorId.innerHTML,
      projectVersion: this.form.value.projectVersion,
      languageId: this.form.value.languageId,
      screenManagementId: this.form.value.screenManagementId,
      projectManagementId: this.project.id,
      id: this.form.value.id,
    });
    this.form.markAsDirty();
  }

  handleFaqSelection(selectedValue: string) {
    const selection = window.getSelection();

    if (!selection.isCollapsed) {
      const range = selection.getRangeAt(0);
      const selectedText = selection.toString();

      let ancestorSpan = null;
      let node = range.commonAncestorContainer;
      while (node) {
        if (node.nodeType === 1 && (node as Element).nodeName === "SPAN") {
          ancestorSpan = node as Element;
          break;
        }
        node = node.parentNode;
      }

      if (ancestorSpan && ancestorSpan.textContent.trim() === selectedText) {
        if (ancestorSpan.hasAttribute("workflowtrigger")) {
          ancestorSpan.removeAttribute("workflowtrigger");
        }
        ancestorSpan.setAttribute("faqtrigger", selectedValue);
      } else {
        const newNode = document.createElement("span");
        newNode.setAttribute("faqtrigger", selectedValue);
        newNode.textContent = selectedText;
        newNode.style.color = "blue";
        newNode.style.cursor = "pointer";
        range.deleteContents();
        range.insertNode(newNode);
      }
      setTimeout(() => {
        var editorId = document.querySelector(".angular-editor-textarea");
        this.form.setValue({
          name: this.form.value.name,
          text: editorId.innerHTML,
          projectVersion: this.form.value.projectVersion,
          languageId: this.form.value.languageId,
          screenManagementId: this.form.value.screenManagementId,
          projectManagementId: this.project.id,
          id: this.form.value.id,
        });
        this.form.markAsDirty();
      }, 100);
    }

    selection.removeAllRanges();
  }

  handleClassSelection(selectedValue: string) {
    const selection = window.getSelection();

    if (!selection.isCollapsed && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      let ancestorElement = null;
      let node = range.commonAncestorContainer;

      // Find the nearest ancestor element
      while (node) {
        if (node.nodeType === 1) {
          ancestorElement = node as Element;
          break;
        }
        node = node.parentNode;
      }

      if (selectedValue === "clear-class") {
        // Remove class from the selected element
        if (ancestorElement) {
          ancestorElement.removeAttribute("class");
          setTimeout(() => {
            this.updateFormContent();
          }, 100);
        }
      } else {
        // Check if the selected content includes an image
        if (ancestorElement && ancestorElement.nodeName === "IMG") {
          // Apply class directly to the image
          ancestorElement.setAttribute("class", selectedValue);
        } else {
          // Apply class to the selected text or elements that are not images
          if (range.startContainer.parentNode.nodeName !== "IMG") {
            const newNode = document.createElement("span");
            newNode.setAttribute("class", selectedValue);
            newNode.appendChild(range.extractContents()); // Retain the original content inside the new span
            const dropdown = document.getElementById(
              "class-faq-editor"
            ) as HTMLSelectElement;
            if (dropdown) {
              dropdown.value = selectedValue;
            }
            // Insert the new node in place of the original selection
            range.insertNode(newNode);

            // Clear the selection to avoid duplicating spans
            selection.removeAllRanges();
          }
        }

        setTimeout(() => {
          this.updateFormContent();
        }, 100);
      }
    }
  }

  // /* Append span tag here for selected roles from the dropdown. */
  // handleRolesSelection(updatedRoles: string[]) {
  //   setTimeout(() => {
  //     const selection = window.getSelection();
  //     if (!selection || selection.isCollapsed) return;

  //     const range = selection.getRangeAt(0);
  //     let roleSpan = this.findClosestRoleSpan(range.startContainer);

  //     if (roleSpan) {
  //       // ✅ Update existing span roles
  //       this.updateSpanRoles(roleSpan, updatedRoles);
  //     } else if (updatedRoles.length > 0) {
  //       // ✅ Wrap selection in a new span
  //       this.wrapSelectionWithRoles(range, updatedRoles);
  //     }
  //   }, 0);
  // }

  // /** ✅ Finds the closest role span ancestor */
  // private findClosestRoleSpan(node: Node): HTMLElement | null {
  //   let element =
  //     node.nodeType === Node.ELEMENT_NODE
  //       ? (node as HTMLElement)
  //       : node.parentElement;

  //   while (element && element !== this.editorRef.nativeElement) {
  //     if (
  //       element.tagName === "SPAN" &&
  //       (element.classList.contains("applied-class") ||
  //         Array.from(element.classList).some((cls) =>
  //           cls.startsWith("_tas-role-")
  //         ))
  //     ) {
  //       return element;
  //     }
  //     element = element.parentElement;
  //   }
  //   return null;
  // }

  // /** ✅ Updates roles on an existing span */
  // private updateSpanRoles(span: HTMLElement, updatedRoles: string[]): void {
  //   // Remove old roles not in updatedRoles
  //   Array.from(span.classList)
  //     .filter((cls) => cls.startsWith("_tas-role-"))
  //     .forEach((cls) => {
  //       if (!updatedRoles.includes(cls.replace("_tas-role-", ""))) {
  //         span.classList.remove(cls);
  //       }
  //     });

  //   // Add new roles
  //   updatedRoles.forEach((role) => span.classList.add(`_tas-role-${role}`));

  //   // Ensure applied-class exists
  //   if (!span.classList.contains("applied-class")) {
  //     span.classList.add("applied-class");
  //   }
  // }

  // /** ✅ Wraps current selection with a span containing roles */
  // private wrapSelectionWithRoles(range: Range, updatedRoles: string[]): void {
  //   const wrapper = document.createElement("span");
  //   updatedRoles.forEach((role) => wrapper.classList.add(`_tas-role-${role}`));
  //   wrapper.classList.add("applied-class");
  //   wrapper.appendChild(range.extractContents());
  //   range.insertNode(wrapper);
  // }

  handleWorkflowSelection(selectedValue: string) {
    const selection = window.getSelection();

    // 1. Insert the workflow div when "4-workflows" or "all-workflows" is selected
    if (selectedValue === "4-workflows" || selectedValue === "all-workflows") {
      const range = selection.getRangeAt(0);
      let htmlToInsert = "";

      if (selectedValue === "4-workflows") {
        htmlToInsert = `
          <br>
          <div class="_tas-top4-worflows">
            <h3>Key workflows</h3>
            <table class="_tas-table">
              <tbody class="_tas-table-body">
                <tr>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                </tr>
                <tr>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                </tr>
              </tbody>
            </table>
          </div>`;
      } else if (selectedValue === "all-workflows") {
        htmlToInsert = `
          <br>
          <div class="_tas-all-workflows">
            <h3>All workflows</h3>
            <table class="_tas-table">
              <tbody class="_tas-table-body">
                <tr>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                </tr>
                <tr>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                </tr>
                <tr>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                </tr>
                <tr>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                </tr>
                <tr>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                  <td><span style="color: blue; cursor: pointer;" workflowtrigger=""></span></td>
                </tr>
              </tbody>
            </table>
          </div>`;
      }

      // Insert the HTML into the editor at the current cursor position
      if (htmlToInsert) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlToInsert;

        const fragment = document.createDocumentFragment();
        while (tempDiv.firstChild) {
          fragment.appendChild(tempDiv.firstChild);
        }

        range.deleteContents(); // Clear any existing content in the range
        range.insertNode(fragment); // Insert the new HTML content at the range

        // Move the cursor after the inserted content
        range.collapse(false); // Collapse the range to the end of the inserted content

        // Update the form with the new editor content
        setTimeout(() => {
          const editorId = document.querySelector(".angular-editor-textarea");
          this.form.setValue({
            name: this.form.value.name,
            text: editorId.innerHTML, // Update form with new editor content
            projectVersion: this.form.value.projectVersion,
            languageId: this.form.value.languageId,
            screenManagementId: this.form.value.screenManagementId,
            projectManagementId: this.project.id,
            id: this.form.value.id,
          });
          this.form.markAsDirty();
        }, 100);
      }
    }

    // 2. Handle text selection and workflow trigger for other options
    else if (!selection.isCollapsed) {
      const range = selection.getRangeAt(0);
      const selectedText = selection.toString();
      if (selectedText.trim()) {
        let ancestorSpan = null;
        let node = range.commonAncestorContainer;

        // Find the nearest ancestor <span> in the selection (if any)
        while (node) {
          if (node.nodeType === 1 && (node as Element).nodeName === "SPAN") {
            ancestorSpan = node as Element;
            break;
          }
          node = node.parentNode;
        }

        // If there's an ancestor span with the same text, modify it
        if (ancestorSpan && ancestorSpan.textContent.trim() === selectedText) {
          if (ancestorSpan.hasAttribute("faqtrigger")) {
            ancestorSpan.removeAttribute("faqtrigger");
          }
          ancestorSpan.setAttribute("workflowtrigger", selectedValue);
          ancestorSpan.style.color = "blue";
          ancestorSpan.style.cursor = "pointer";
        } else {
          // Otherwise, create a new span around the selected text
          var newSpan = document.createElement("span");
          newSpan.setAttribute("workflowtrigger", selectedValue);
          newSpan.textContent = selectedText;
          newSpan.style.color = "blue";
          newSpan.style.cursor = "pointer";

          range.deleteContents(); // Remove the currently selected text
          range.insertNode(newSpan); // Insert the new span in place of the selected text
        }

        // Collapse the range to the end of the newly inserted span
        range.setStartAfter(ancestorSpan || newSpan);
        range.collapse(false);

        // Update the form with the new editor content
        setTimeout(() => {
          const editorId = document.querySelector(".angular-editor-textarea");
          this.form.setValue({
            name: this.form.value.name,
            text: editorId.innerHTML, // Update form with new editor content
            projectVersion: this.form.value.projectVersion,
            languageId: this.form.value.languageId,
            screenManagementId: this.form.value.screenManagementId,
            projectManagementId: this.project.id,
            id: this.form.value.id,
            linkedFAQ: this.form.value.linkedFAQ,
            linkedWorkflow: this.form.value.linkedWorkflow,
            roles: [],
          });
          this.form.markAsDirty();
        }, 100);
      }
    }

    // Clear the selection after insertion
    selection.removeAllRanges();
  }

  getlastPublishStage(userGuideId) {
    this.crudService.get(
      null,
      (response) => {
        if (response.publishStage == "dev") {
          this.publishToQA = true;
          this.publishToProd = false;
          this.disbledPublishtoDev = true;
        } else if (response.publishStage == "qa") {
          this.publishToQA = false;
          this.disbledPublishtoDev = true;
          this.publishToProd = true;
        } else if (response.publishStage == "prod") {
          this.publishToProd = false;
          this.disbledPublishtoDev = true;
          this.publishToQA = false;
        }
      },
      `currentUserGuideDetails/findOne?filter[order]=updatedAt DESC&filter[where][userGuideId]=${userGuideId}`
    );
  }

  get f() {
    return this.form.controls;
  }

  getLanguages() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.languageList = response;
      },
      "languages"
    );
  }

  countImagesInText(text: string): number {
    const imgTags = text.match(/<img\s+[^>]*src="[^"]*"[^>]*>/g);
    return imgTags ? imgTags.length : 0;
  }
  onSubmit() {
    const editor = document.getElementById("faq-editor1") as HTMLElement;

    var cleanedHtml;
    this.submitted = true;
    var self = this;
    var editorContent = editor.querySelector("div[contenteditable='true']"); // Or use the correct tag/selector based on the editor's internal structure
    if (editorContent) {
      // Get the inner HTML of the content
      var htmlContent = editorContent.innerHTML;

      // Create a temporary container to manipulate the HTML (to safely clean it up)
      var tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;

      // Remove Angular-specific classes and attributes from all child elements
      var elements = tempDiv.querySelectorAll("*");

      elements.forEach((element: any) => {
        // Remove Angular-specific classes
        var classList = element.classList;
        classList.forEach((cls) => {
          if (
            cls.startsWith("ng-") ||
            cls.startsWith("_ngcontent-") ||
            cls.startsWith("_nghost-") ||
            cls.startsWith("ng-reflect-") ||
            cls.startsWith("ng-star-inserted")
          ) {
            element.classList.remove(cls); // Remove Angular class
          }
        });

        // Remove Angular-specific attributes
        for (let attr of element.attributes) {
          if (
            attr.name.startsWith("_ngcontent-") ||
            attr.name.startsWith("_nghost-") ||
            attr.name.startsWith("ng-reflect-") ||
            attr.name.startsWith("ng-star-inserted")
          ) {
            element.removeAttribute(attr.name); // Remove Angular attribute
          }
        }
      });

      // Get the cleaned-up HTML content (without Angular classes and attributes)
      cleanedHtml = tempDiv.innerHTML;
    } else {
    }
    if (!this.form.value.text) {
      this.textError = true;
      return;
    } else {
      this.textError = false;
    }
    if (this.form.invalid) return;
    var imageUrls = this.countImagesInText(this.form.value.text);
    if (imageUrls > this.imageLength) {
      this.imageError = true;
      return;
    } else {
      this.imageError = false;
    }

    var payload: any = {};
    payload["linkedFAQ"] = "";
    payload["publishStage"] = "";

    if (
      (document.getElementById("faq-faq-editor") as HTMLSelectElement).value !=
      ""
    ) {
      payload["linkedFAQ"] = (
        document.getElementById("faq-faq-editor") as HTMLSelectElement
      ).value;
    }

    if (this.existingUserguides.length == 0) {
      /* This will be executed if the useruide is being created for the first time */

      var userGuidePayload = {
        languageId: this.project.primaryLanguage,
        screenManagementId: this.screen.id,
        projectManagementId: this.project.id,
        text: cleanedHtml ? cleanedHtml : this.form.value.text,
      };

      this.crudService.post(
        userGuidePayload,
        (response) => {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            payload = {
              ...self.form.value,
              publishStage: "dev",
              languageId: this.project["primaryLanguage"],
              screenManagementId: this.screen["id"],
              projectManagementId: this.project.id,
              userGuideId: response.id,
              projectVersion: this.projectVersion,
            };

            self.crudService.post(
              payload,
              function (response) {
                if (
                  response.error &&
                  response.error.error &&
                  response.error.error.message
                ) {
                  self.toastr.error(
                    response.error.error.message,
                    "Invalid Operation"
                  );
                  self.form.markAsPristine();
                  self.formStateService.clearFormDirty();
                } else {
                  self.toastr.success(
                    "The User Guide has been created successfully.",
                    "Success"
                  );
                  self.formSubmitted.emit();
                  self.currentUserGuide = response;
                  self.form.markAsPristine();
                  self.formStateService.clearFormDirty();

                  self.getlastPublishStage(self.currentUserGuide.userGuideId);
                }
              },
              "currentUserGuideDetails"
            );
          }
        },
        "userGuides"
      );
    } else {
      /* This will be executed if we're updating something on dev */
      let payload: any = {};

      // Append form.value first
      if (
        (document.getElementById("faq-faq-editor") as HTMLSelectElement).value
      ) {
        payload["linkedFAQ"] = (
          document.getElementById("faq-faq-editor") as HTMLSelectElement
        ).value;
      }

      let filteredItems: any[] = [];

      filteredItems = this.existingUserguides.filter(
        (item) => item.publishStage === "dev"
      );
      payload["publishStage"] = "dev";

      // Merge filtered items into payload

      payload = {
        ...(Array.isArray(filteredItems) ? filteredItems[0] : filteredItems),
        ...payload,
        ...this.form.value,
        text: cleanedHtml ? cleanedHtml : this.form.value.text,
        id: filteredItems[0]["id"],
      };

      payload["languageId"] = this.project["primaryLanguage"];

      this.crudService.update(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
          } else {
            self.currentUserGuide = response;
            self.toastr.success(
              "The User Guide has been updated successfully.",
              "Success"
            );
            self.formSubmitted.emit();
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
            self.getlastPublishStage(self.currentUserGuide.userGuideId);
          }
        },
        "currentUserGuideDetails/" + payload["id"]
      );
    }
    this.submitted = false;
  }

  onReset() {
    this.submitted = false;
    if (this.addUserGuide) {
      this.form.reset();
      this.formStateService.clearFormDirty();
    } else {
      this.form.patchValue(this.currentUserGuide);
      this.form.markAsPristine();
      this.formStateService.clearFormDirty();
    }
  }

  onClickOfPublish(publishStage: string) {
    var self = this;
    var payload = {};
    if (this.form.invalid) return;
    var imageUrls = this.countImagesInText(this.form.value.text);
    if (imageUrls > this.imageLength) {
      this.imageError = true;
      return;
    } else {
      this.imageError = false;
    }

    // payload = this.form.value;
    var filteredValue: any[] = [];
    if (publishStage == "qa") {
      filteredValue = this.existingUserguides
        .filter((item) => item.publishStage == "qa")
        .map((item) => ({
          ...item,
          // publishStage: "qa",
        }));
    } else if (publishStage == "prod") {
      filteredValue = this.existingUserguides
        .filter((item) => item.publishStage == "prod")
        .map((item) => ({
          ...item,
          // publishStage: "prod",
        }));
    }
    const ignoreKey = "publishStage";
    const keys = Object.keys(filteredValue).filter((key) => key !== ignoreKey);

    if (this.existingUserguides.length == 0) {
      payload = {
        ...(Array.isArray(filteredValue) ? filteredValue[0] : filteredValue),
        ...this.form.value,
        id: filteredValue["id"],
      };
      payload["languageId"] = this.project["primaryLanguage"];
      payload["publishStage"] = publishStage;
      this.crudService.post(
        payload,
        (response) => {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
            this.form.markAsPristine();
            this.formStateService.clearFormDirty();
          } else {
            this.toastr.success(
              "User Guide has been published successfully.",
              "Success"
            );
            this.formSubmitted.emit();
            this.form.markAsPristine();
            this.formStateService.clearFormDirty();
          }
        },
        "currentUserGuideDetails"
      );
    } else {
      if (keys.length == 0) {
        payload = {
          ...this.userguide,
          ...this.form.value,
          id: undefined,
        };
        payload["languageId"] = this.project["primaryLanguage"];
        payload["publishStage"] = publishStage;
        this.crudService.post(
          payload,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
              self.form.markAsPristine();
              self.formStateService.clearFormDirty();
            } else {
              self.toastr.success(
                "User Guide has been published successfully.",
                "Success"
              );
              self.formSubmitted.emit();
              self.form.markAsPristine();
              self.formStateService.clearFormDirty();
            }
          },
          "currentUserGuideDetails"
        );
      } else {
        payload = {
          ...(Array.isArray(filteredValue) ? filteredValue[0] : filteredValue),
          ...this.form.value,
          id: filteredValue[0]["id"],
        };
        payload["languageId"] = this.project["primaryLanguage"];
        payload["publishStage"] = publishStage;
        this.crudService.update(
          payload,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
              self.form.markAsPristine();
              self.formStateService.clearFormDirty();
            } else {
              self.toastr.success(
                "User Guide has been published successfully.",
                "Success"
              );
              self.formSubmitted.emit();
              self.form.markAsPristine();
              self.formStateService.clearFormDirty();
            }
          },
          "currentUserGuideDetails/" + payload["id"]
        );
      }
    }
    self.getlastPublishStage(this.currentUserGuide.userGuideId);
  }

  showSelectedLangaugeUserGuide(languageId) {
    let self = this;

    if (languageId === self.project.primaryLanguage) {
      if (this.addUserGuide) {
        this.currentUserGuide = Object.assign({}, this.currentUserGuide);
      } else {
        this.currentUserGuide = Object.assign({}, this.userguide);
      }
      this.form.patchValue(this.currentUserGuide);
      self.onLanguageChange.emit({
        id: self.currentUserGuide.id,
        name: self.getLanguageName(languageId),
      });
    } else if (languageId !== self.project.primaryLanguage) {
      self.crudService.get(
        null,
        function (response) {
          var isUserGuideExistForSelectedLangauge =
            response &&
            response.length &&
            response.find(function (val) {
              return val.languageId === languageId;
            });
          if (isUserGuideExistForSelectedLangauge) {
            self.currentUserGuide = isUserGuideExistForSelectedLangauge;
            self.form.patchValue(isUserGuideExistForSelectedLangauge);
            self.onLanguageChange.emit({
              id: self.currentUserGuide.parentId,
              name: self.getLanguageName(languageId),
            });
          } else {
            let newobj = {
              ...self.currentUserGuide,
              parentId: self.currentUserGuide.id,
            };
            newobj.languageId = languageId;
            delete newobj.id;
            self.crudService.post(
              newobj,
              function (response) {
                if (
                  response.error &&
                  response.error.error &&
                  response.error.error.message
                ) {
                  self.toastr.error(
                    response.error.error.message,
                    "Invalid Operation"
                  );
                } else {
                  self.toastr.success(
                    "User Guide has been created for new language successfully.",
                    "Success"
                  );
                  self.formSubmitted.emit();
                  self.currentUserGuide = response;
                  self.form.patchValue(response);
                  self.onLanguageChange.emit({
                    id: self.currentUserGuide.parentId,
                    name: self.getLanguageName(languageId),
                  });
                }
              },
              "currentUserGuideDetails"
            );
          }
        },
        'currentUserGuideDetails?filter={"where":{"parentId":"' +
          self.currentUserGuide.id +
          '"}}'
      );
    }
  }

  getLanguageName(languageId) {
    if (this.languageList.length) {
      var langauge = this.languageList.find(function (val) {
        return val.id === languageId;
      });
      if (langauge) {
        return langauge.name;
      } else {
        return "English";
      }
    }
  }

  navigateProjectScreen() {
    this.router.navigate(["/page/project-management", this.project.id]);
  }

  open(content) {
    this.modalService.open(content);
  }

  getNewLanguage() {
    var self = this;
    var newlan = [];
    self.languageList.forEach(function (lan) {
      var isExist = self.project.supportedLanguage.find(function (sl) {
        return sl.id === lan.id;
      });
      if (!isExist && lan.id != self.project.primaryLanguage) {
        newlan.push(lan);
      }
    });
    return newlan;
  }

  saveNewSelectedLanguage(newLanguageList) {
    var self = this;
    if (newLanguageList.selectedOptions.selected.length) {
      newLanguageList.selectedOptions.selected.forEach((selectedNewLan) => {
        var isExist = self.languageList.find(function (sl) {
          return sl.name == selectedNewLan.getLabel().trim();
        });
        if (isExist) {
          self.project.supportedLanguage.push(isExist);
        }
      });

      self.crudService.update(
        self.project,
        function (response) {
          if (response) {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              self.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              self.project = response;
              self.toastr.success(
                "New language added successfully to the project.",
                "Success"
              );
            }
          }
        },
        "projectManagements"
      );
    }
    self.modalService.dismissAll();
  }

  onRoleSelectionChanges(event) {
    this.dropdownSelection = event;

    // console.log("event here ", event);
  }

  onEditorClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const paragraph =
      target.closest("p") || target.closest("div") || target.closest("span"); // Find closest <p> tag

    this.isSelectingText = false;
    if (paragraph) {
      this.showDropdown(event); // Show dropdown for the clicked paragraph
      const spans = paragraph.querySelectorAll('span[class^="_tas-role-"]');
      spans.forEach((span) => {
        // console.log("Found:", span.outerHTML);
      });
    }
  }

  onTextSelect(event) {
    if (this.isDropdownOpen) {
      return;
    } else {
      this.isSelectingText = true;
      const selectedText = window.getSelection();

      if (selectedText) {
        this.showDropdown(event);
        this.onDropdownClick(event);
      }

      this.setDropdownValueBasedOnSpan();
    }
  }

  // Show the dropdown and position it near the selected text
  showDropdown(event: MouseEvent) {
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    if (range && selection.rangeCount > 0) {
      this.selectionRange = range;
      const rect = range.getBoundingClientRect();
    }
  }

  /* This function is used to handle the click event of the dropdown.
   where it prevents the dropdown from closing when the user selects the paragraph inside the editor. */
  onDropdownClick(event) {
    this.isDropdownOpen = true;
    event.stopPropagation();
    event.preventDefault();
    if (this.selectionRange) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      // this.handleRolesSelection(this.selectedRoles);
      selection.addRange(this.selectionRange); // Reapply the original selection
    }
  }

  /* if, selected paragraph has class _tas-role- then set the value of dropdown is selected here */
  setDropdownValueBasedOnSpan() {
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed) {
      // this.selectedRoles = [];
      return;
    }

    const selectedRange = selection.getRangeAt(0);
    const selectedElement = selectedRange.startContainer.parentElement;

    if (selectedElement && selectedElement.classList) {
      const roleClasses = Array.from(selectedElement.classList).filter(
        (className) => className.includes("_tas-role-")
      );

      if (roleClasses.length > 0) {
        const roleValues = roleClasses.map((roleClass) => {
          return roleClass.replace("_tas-role-", "");
        });

        // Set the value of selected roles (this binds to ngModel)
        this.selectedRoles = roleValues;
      } else {
        // this.selectedRoles = [];
      }
    }
  }

  onRoleRemoved(event) {
    const selection = window.getSelection();

    if (!selection || selection.isCollapsed) {
      return;
    }

    const selectedRange = selection.getRangeAt(0);
    const classToRemove = `_tas-role-${event.value.name}`;

    const fragment = selectedRange.cloneContents();
    const spansInSelection = fragment.querySelectorAll("span");

    // Loop through the original DOM to remove class only in the selected range
    spansInSelection.forEach((clonedSpan) => {
      const textContent = clonedSpan.textContent.trim();
      if (!textContent) return;

      // Use TreeWalker to match the same span in the live DOM
      const treeWalker = document.createTreeWalker(
        selectedRange.commonAncestorContainer,
        NodeFilter.SHOW_ELEMENT,
        {
          acceptNode: (node: any) => {
            return node.nodeType === 1 && node.tagName === "SPAN"
              ? NodeFilter.FILTER_ACCEPT
              : NodeFilter.FILTER_SKIP;
          },
        }
      );

      let currentNode = treeWalker.currentNode;
      while (currentNode) {
        if (
          currentNode instanceof Element &&
          currentNode.classList.contains(classToRemove)
        ) {
          currentNode.classList.remove(classToRemove);

          // Optionally remove 'applied-class' if it's empty of _tas-role-* classes
          const stillHasRole = Array.from(currentNode.classList).some((cls) =>
            cls.startsWith("_tas-role-")
          );
          if (!stillHasRole) {
            currentNode.classList.remove("applied-class");
          }
        }

        currentNode = treeWalker.nextNode();
      }
    });
  }
  rewriteUserguide() {
    const modalref = this.modalService.open(GenerateAiContentComponent, {
      backdrop: "static",
      windowClass: "top-modal custom-width-modal",
    });
    modalref.componentInstance.title = "User Guide";
    modalref.componentInstance.screenId = this.screen["id"];
    modalref.componentInstance.currentScreen = this.screen;
    modalref.componentInstance.projectId = this.project["id"];
    modalref.componentInstance.selectedVersion = this.projectVersion;
    modalref.componentInstance.prompt = `You are an expert UX writer and technical communicator.
   Below this prompt, I have attached a user guide (in raw HTML or plain text format) that needs to be rewritten.
   The goal is to improve its language while keeping it in English only.
   Please do not translate it into any other language — just rewrite it in clear, correct, and user-friendly English.
   📎Attached Content (after this prompt):
   [Here, existing user guide will be attached] `;
    modalref.componentInstance.userGuideText = this.userguide["text"];
    modalref.componentInstance.toReWrite = true;

    modalref.componentInstance.isLoaded.subscribe((response) => {
      this.isLoading = response;
    });
    modalref.componentInstance.contentResponseforUserGuide.subscribe(
      (response) => {
        this.loadingService.hide();
        this.isLoading = false;
        this.form.get("text")?.setValue(response);
        this.form.get("text")?.markAsDirty();
        this.form.get("text")?.markAsTouched();

        this.disbledPublishtoDev = false;
        this.form.markAsDirty();
        this.cdRef.detectChanges();
      }
    );
    modalref.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return "by pressing ESC";
      case ModalDismissReasons.BACKDROP_CLICK:
        return "by clicking on a backdrop";
      default:
        return `with: ${reason}`;
    }
  }

  onSelectionChange(_: any) {
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) {
      this.resetDropdown();
      return;
    }
  }
  private resetDropdown() {
    this.selectedRoles = [];
  }
}

/* 
two code chunks for applying roles dropdown to the selected roles 

1. const selection = window.getSelection();

if (selection && !selection.isCollapsed) {
  const range = selection.getRangeAt(0);

  // Get contents inside the range without removing them
  const content = range.cloneContents();

  // Try to find an existing span with our class within the selection
  const spanWithRoles = content.querySelector("span");

  if (
    spanWithRoles &&
    [...spanWithRoles.classList].some((c) => c.startsWith("_tas-role-") || c === "applied-class")
  ) {
    // ✅ Append roles to existing span
    this.selectedRoles.forEach((role) => {
      const roleClass = `_tas-role-${role}`;
      if (!spanWithRoles.classList.contains(roleClass)) {
        spanWithRoles.classList.add(roleClass);
      }
    });

    if (!spanWithRoles.classList.contains("applied-class")) {
      spanWithRoles.classList.add("applied-class");
    }

    // Insert updated content back
    range.deleteContents();
    range.insertNode(content);
  } else {
    // ✅ Wrap selection with new span if none exists
    const wrapper = document.createElement("span");

    this.selectedRoles.forEach((role) => {
      wrapper.classList.add(`_tas-role-${role}`);
    });
    wrapper.classList.add("applied-class");

    try {
      // Wrap the selected content
      wrapper.appendChild(range.extractContents());
      range.insertNode(wrapper);
    } catch (err) {
      console.warn("Failed to wrap content", err);
    }
  }
}

----

2.  const selection = window.getSelection();
      if (!selection || selection.isCollapsed) return;

      const range = selection.getRangeAt(0);
      const fragment = range.cloneContents();
      const spanWrapper = document.createElement("span");

      // STEP 1: Remove all nested spans from the fragment
      const unwrapSpans = (node: Node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const el = node as HTMLElement;
          if (
            el.tagName.toLowerCase() === "span" &&
            (el.classList.contains("applied-class") ||
              Array.from(el.classList).some((c) => c.startsWith("_tas-role-")))
          ) {
            const parent = el.parentNode!;
            while (el.firstChild) parent.insertBefore(el.firstChild, el);
            parent.removeChild(el);
          } else {
            [...el.childNodes].forEach(unwrapSpans);
          }
        }
      };
      [...fragment.childNodes].forEach(unwrapSpans);

      // STEP 2: Wrap the cleaned content in a single span
      this.selectedRoles.forEach((role) => {
        spanWrapper.classList.add(`_tas-role-${role}`);
      });
      spanWrapper.classList.add("applied-class");

      // Preserve content structure
      while (fragment.firstChild) {
        spanWrapper.appendChild(fragment.firstChild);
      }

      // STEP 3: Replace the original content
      range.deleteContents();
      range.insertNode(spanWrapper);
    });
*/
